import React from 'react';
import _ from 'lodash';
import type { Moment } from 'moment';
import { Radio } from '@this/src/components/shared/ui/inputs/radio';
import { Select } from '@this/src/components/shared/ui/inputs/select';
import { Checkbox } from '@this/src/components/shared/ui/inputs/checkbox';
import { Input } from '@this/src/components/shared/ui/inputs/input';
import { SearchArea, SearchBlock, SearchLabel } from '../../../search_area';
import DateRangePicker from '../../../date_range_picker';
import type { InventoryStatus, SortKey, SortDirection } from './types';

interface Props {
  inventoryStatus: InventoryStatus;
  tripId?: number;
  requestedDateFrom?: Moment;
  requestedDateTo?: Moment;
  sortKey: SortKey;
  sortDirection: SortDirection;
  isPaginate: boolean;
  setInventoryStatus: (inventoryStatus: InventoryStatus) => void;
  setTripId: (tripId?: number) => void;
  setRequestedDateFrom: (requestedDateFrom?: Moment) => void;
  setRequestedDateTo: (requestedDateTo?: Moment) => void;
  setSortKey: (sortKey: SortKey) => void;
  setSortDirection: (sortDirection: SortDirection) => void;
  setIsPaginate: (isPaginate: boolean) => void;
  renderOrganizationSelector: () => JSX.Element;
}

const CancelSearchArea: React.FC<Props> = ({
  inventoryStatus,
  tripId,
  requestedDateFrom,
  requestedDateTo,
  sortKey,
  sortDirection,
  isPaginate,
  setInventoryStatus,
  setTripId,
  setRequestedDateFrom,
  setRequestedDateTo,
  setSortKey,
  setSortDirection,
  setIsPaginate,
  renderOrganizationSelector
}) => {
  return (
    <SearchArea>
      <SearchBlock>
        <SearchLabel>棚卸ステータス</SearchLabel>
        <Select
          value={inventoryStatus}
          onChange={e => setInventoryStatus(e.target.value as InventoryStatus)}
          style={{ marginBottom: 0, marginRight: '5px' }}
        >
          <option value="not_yet">未</option>
          <option value="done">済</option>
          <option value="all">全て</option>
        </Select>
      </SearchBlock>
      <SearchBlock>
        <SearchLabel>Trip ID</SearchLabel>
        <Input
          value={tripId || ''}
          onChange={e => {
            const parsed = parseInt(e.target.value, 10);
            setTripId(Number.isNaN(parsed) ? undefined : parsed);
          }}
          style={{ width: '80px' }}
        />
      </SearchBlock>
      <SearchBlock>
        <SearchLabel>キャンセル依頼日</SearchLabel>
        <DateRangePicker
          from={requestedDateFrom}
          to={requestedDateTo}
          onFromChange={d => setRequestedDateFrom(d)}
          onToChange={d => setRequestedDateTo(d)}
        />
      </SearchBlock>
      <SearchBlock>
        <SearchLabel>法人</SearchLabel>
        {renderOrganizationSelector()}
      </SearchBlock>
      <SearchBlock>
        <SearchLabel>並び順</SearchLabel>
        <Select
          value={sortKey}
          onChange={e => setSortKey(e.target.value as SortKey)}
          style={{ marginBottom: 0, marginRight: '5px' }}
        >
          <option value="requested_at">キャンセル依頼日</option>
        </Select>
        <Radio
          checked={sortDirection === 'asc'}
          onChange={() => setSortDirection('asc')}
          style={{ marginRight: '5px' }}
        >
          昇順▲
        </Radio>
        <Radio checked={sortDirection === 'desc'} onChange={() => setSortDirection('desc')}>
          降順▼
        </Radio>
      </SearchBlock>
      <SearchBlock>
        <Checkbox checked={isPaginate} onChange={e => setIsPaginate(e.target.checked)}>
          <b style={{ fontSize: '12px' }}>ページネーションを利用</b>
        </Checkbox>
      </SearchBlock>
    </SearchArea>
  );
};

export default CancelSearchArea;
